import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "../../../../../common/Button/Button";
import CommonDatePicker from "../../../../../common/Formik/DatePiker/DatePicker";
import ErrorText from "../../../../../common/Formik/ErrorText/ErrorText";
import InputFormik from "../../../../../common/Formik/Input/InputFormik";
import Textarea from "../../../../../common/Formik/Textarea/Textarea";
import Upload from "../../../../../common/Formik/Upload/Upload";
import styles from "../ReportIssues.module.scss";
import { reportIssueAction } from "../../../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { format } from "date-fns";
const blobToBase64 = (blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

const WrongDeducation = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false);

  const MAX_FILE_SIZE_MB = 2;
  const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

  const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "application/pdf",
  ];

  const validationSchema = Yup.object({
    transactionId: Yup.string()
      .trim()
      .required("Transaction ID is required")
      .min(6, "Transaction ID must be at least 6 characters")
      .max(50, "Transaction ID must not exceed 50 characters"),

    AmountDeducted: Yup.number()
      .typeError("Amount deducted must be a number")
      .required("Amount deducted is required")
      .positive("Amount deducted must be greater than 0"),

    ExpectedAmount: Yup.number()
      .typeError("Expected amount must be a number")
      .required("Expected amount is required")
      .positive("Expected amount must be greater than 0")
      .test(
        "greater-than-deducted",
        "Expected amount must be greater than deducted amount",
        function (value) {
          const { AmountDeducted } = this.parent;
          if (!value || !AmountDeducted) return true;
          return value > AmountDeducted;
        }
      ),

    date: Yup.date()
      .typeError("Invalid transaction date")
      .nullable()
      .required("Transaction date is required")
      .max(new Date(), "Transaction date cannot be in the future"),

    MerchantName: Yup.string()
      .trim()
      .max(100, "Merchant name must not exceed 100 characters")
      .nullable(),

    description: Yup.string()
      .trim()
      .required("Description is required")
      .min(10, "Description must be at least 10 characters")
      .max(500, "Description must not exceed 500 characters"),

    profile_img: Yup.mixed()
      .nullable()
      .test(
        "fileExists",
        "Invalid file",
        (file) => !file || file instanceof File
      )

      //  Size validation
      .test(
        "fileSize",
        `File size must be less than ${MAX_FILE_SIZE_MB} MB`,
        (file) => !file || file.size <= MAX_FILE_SIZE
      )

      //  Type validation (MIME)
      .test(
        "fileType",
        "Only JPG, JPEG, PNG, or PDF files are allowed",
        (file) => !file || SUPPORTED_FORMATS.includes(file.type)
      )

      //  Extension safety (extra layer)
      .test(
        "fileExtension",
        "Invalid file extension",
        (file) => {
          if (!file) return true;
          const ext = file.name?.split(".").pop()?.toLowerCase();
          return ["jpg", "jpeg", "png", "pdf"].includes(ext);
        }
      ),

  });
  const reportSubmit = async (values, resetForm) => {
    try {
      setLoading(true);

      let attachments;

      if (values.profile_img) {
        const base64 = await blobToBase64(values.profile_img);
        attachments = [base64]; // backend expects array
      }

      const payload = {
        amount: Number(values.AmountDeducted),
        expected_amount: Number(values.ExpectedAmount),
        description: values.description,
        dispute_type: "wrong_deduction",
        transaction_id: values.transactionId,
        transaction_date: format(new Date(values.date), "yyyy-MM-dd"),
        ...(values.MerchantName && { merchant_name: values.MerchantName }),
        ...(attachments && { attachments }),
      };


      const res = await dispatch(reportIssueAction(payload));

      if (res?.status === 200 || res?.status === 201) {
        resetForm();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className={styles.report_issues_content}>
      <h5>Report Wrong Deduction</h5>

      <div className={styles.report_issues_content_form}>
        <Formik
          initialValues={{
            transactionId: "",
            ExpectedAmount: "",
            AmountDeducted: "",
            MerchantName: "",
            date: null,
            description: "",
            profile_img: null,
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            reportSubmit(values, resetForm)
          }}
        >
          {(formik) => (
            <Form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
              <Row>
                <Col lg={4} md={6}>
                  <InputFormik
                    name="transactionId"
                    label="Transaction ID"
                    placeholder="Enter transaction ID"
                    className={styles.input}
                    {...formik.getFieldProps("transactionId")}
                    formik={formik}
                  />
                </Col>
                <Col lg={4} md={6}>
                  <InputFormik
                    name="AmountDeducted"
                    label="Amount Deducted"
                    placeholder="$0.00"
                    className={styles.input}
                    {...formik.getFieldProps("AmountDeducted")}
                    formik={formik}
                  />
                </Col>
                <Col lg={4} md={6}>
                  <InputFormik
                    name="ExpectedAmount"
                    label="Expected Amount *"
                    placeholder="$0.00"
                    className={styles.input}
                    {...formik.getFieldProps("ExpectedAmount")}
                    formik={formik}
                  />
                </Col>

                <Col lg={4} md={6}>
                  <CommonDatePicker
                    label="Transaction Date"
                    name="date"
                    value={formik.values.date}
                    placeholder="DD/MM/YYYY"
                    onChange={(date) => formik.setFieldValue("date", date)}
                    onBlur={formik.handleBlur}
                    maxDate={new Date()}
                    formik={formik}
                  />
                </Col>
                <Col lg={4} md={6}>
                  <InputFormik
                    name="MerchantName"
                    label="Merchant Name"
                    placeholder="Enter merchant name"
                    className={styles.input}
                    {...formik.getFieldProps("MerchantName")}
                    formik={formik}
                  />
                </Col>
                <Col lg={6}>
                  <Textarea
                    name="description"
                    label="Description"
                    placeholder="Describe your issue"
                    formik={formik}
                    value={formik.values.description}
                    className={styles.form_textarea}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Col>

                <Col lg={6}>
                  <Upload
                    name="profile_img"
                    label="Upload receipt"
                    formik={formik}
                    image={formik.values.profile_img}
                    setBlobImage={(file) => {
                      formik.setFieldValue("profile_img", file);
                      formik.setFieldTouched("profile_img", true);
                    }}
                  />

                  {formik.touched.profile_img && formik.errors.profile_img && (
                    <ErrorText>{formik.errors.profile_img}</ErrorText>
                  )}
                </Col>
              </Row>
              <div className={styles.form_btns}>
                <Button
                  type="button"
                  className={styles.form_btns_btn}
                  variant="bordered_grey"
                  onClick={() => {
                    // Add cancel logic if needed, e.g. navigate back
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  className={styles.form_btns_btn}
                  disabled={loading}
                  onClick={(e) => {
                    formik.handleSubmit(e);
                  }}
                >
                  {loading ? "Submitting..." : "Submit Issue"}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default WrongDeducation;
